export default __webpack_public_path__ + "static/media/alarm-clock.44943ea1.svg";